<template>
  <page-view
    :title="form ? form.title : state === 'loading' ? 'Loading form' : 'Could not find form'"
    :backLink="backLink"
    :backText="backText"
  >
    <template v-slot:id>
      <template v-if="form">
        <id :id="form.id" />
      </template>
    </template>

    <template v-slot:header-right>
      <template v-if="form">
        <dots class="border left m-r-2">
          <ul>
            <li @click="deleteForm">
              <i class="icon-close-medium" />
                Delete form
            </li>
          </ul>
        </dots>
      </template>
    </template>

    <template v-if="form">
      <table-list :overflowAll="true">
        <template v-slot:table-header>
          <div class="list-header p-a-md-3 ai-md-c">
            <div class="d-f f-1 p-a-2 p-a-md-0">
              <div class="button ml-a">
                <Button icon="accounting-24" class="medium only-text keep-hover blue minimal-border-radius with-extra-side-padding" @click="exportSubmissions">Export</Button>
              </div>
            </div>
          </div>
        </template>
        <tr class="header f-w">
          <th
            :class="`${index === 0 ? form.fields.length < 2 ? 'w-100p' : 'w-50p w-md-50p' : form.fields.length < 4 && index === 1 ? 'w-50p w-md-50p' : 'w-33p'}`"
            :key="index"
            v-for="(field, index) in form.fields"
          >{{ field.label }}</th>
          <th class="w-25p">Created</th>
        </tr>
        <template v-if="submissions && submissions.length > 0">
          <a
            :href="`/customer/${submission.customer.id}`"
            :key="submission.id"
            @click.prevent="handleLink($event, `/customer/${submission.customer.id}`)"
            v-for="submission in submissions"
          >
            <td
              :class="`${index === 0 ? form.fields.length < 2 ? 'w-100p' : 'w-50p w-md-50p' : form.fields.length < 4 && index === 1 ? 'w-50p w-md-50p' : 'w-33p'}`"
              :key="index"
              v-for="(field, index) in form.fields"
            >
              <template v-if="field.name === 'email'">
                <div class="blue">{{ submission.customer.email }}</div>
              </template>
              <template v-else>
                {{ submission.fields[field.name] }}
              </template>
            </td>
            <td>{{ getCreatedAt(submission.created_at) }}</td>
          </a>
        </template>
        <template v-else>
          <a class="empty-list">
            <td colspan="4" class="p-a-4">
              No submissions
            </td>
          </a>
        </template>
      </table-list>
    </template>
    <template v-else>
      <div class="d-f f-1 ai-c jc-c" v-if="state === 'loading'">
        <div class="loading-spinner large"></div>
      </div>
      <div class="d-f f-1 ai-c jc-c" v-else-if="state === 'error'">
        <p>Could not load form</p>
      </div>
    </template>
  </page-view>
</template>

<script>

import moment from 'moment';
import { exportToCsv } from '@/utils';

import TableList from '@/components/Lists/Table.vue';
import Dots from '@/components/Dots.vue';

export default {
  components: {
    Dots,
    TableList,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      backLink: '/customers/form',
      backText: 'Back to customer forms',
      form: null,
      state: 'loading',
      submissions: [],
      checkedSubmissions: [],
    };
  },
  methods: {
    async exportSubmissions() {
      const data = await this.$store.dispatch('Forms/exportSubmissions', this.id);
      if (!data) {
        swal({ title: 'An error occured', text: 'Could not export customer(s)', icon: 'error' });
        return;
      }

      exportToCsv(`${this.form.title.replace(' ', '_')}_submissions_export.csv`, data);
    },
    async getForm() {
      const form = await this.$store.dispatch('Forms/getForm', { id: this.id, doCommit: false });
      this.form = form;

      if (form) {
        this.getSubmissions();
      }
    },
    async getSubmissions() {
      this.submissions = await this.$store.dispatch('Forms/getFormSubmissions', this.id);
    },
    getCreatedAt(date) {
      return Math.abs(moment().diff(date, 'days')) < 2 ? moment(date).from(moment()) : this.$options.filters.formatdate(date, 'MMM Do YYYY');
    },
    async deleteForm() {
      const willDelete = await swal({
        title: this.$t('errors.are_you_sure'), text: 'This will remove form', icon: 'warning', buttons: true, dangerMode: true,
      });

      if (!willDelete) {
        return;
      }

      const deleted = await this.$store.dispatch('Forms/deleteForm', this.id);
      if (!deleted) {
        swal({ title: 'An error occured', text: 'Could not delete form', icon: 'error' });
      }
      this.$router.push(this.backLink);
    },
  },
  async mounted() {
    await this.getForm();
    this.state = '';

    const lastRoute = this.$store.getters['Theme/lastRoute'];
    if (lastRoute && lastRoute.path.includes('customers')) {
      this.backLink = lastRoute.fullPath;
    } else if (lastRoute && lastRoute.path.includes('broadcast')) {
      this.backLink = lastRoute.fullPath;
      this.backText = 'Back to Broadcast';
    }
  },
};
</script>
